import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import type { Testimonial } from '../../types/content';
import { StarRating } from './StarRating';
interface TestimonialCardProps {
  testimonial: Testimonial;
}
export function TestimonialCard({
  testimonial
}: TestimonialCardProps) {
  const {
    t
  } = useLanguage();
  const initials = testimonial.name.split(' ').map(p => p[0]).join('').slice(0, 2);
  return <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.06] p-7 sm:p-8" data-id="element-441" data-mp="2n6y8yg4c6gw3">
      <StarRating size="lg" label={t({
      en: '5 out of 5 stars',
      es: '5 de 5 estrellas'
    })} data-id="element-442" data-mp="2r7qizbl18ptf" />
      <blockquote className="mt-6 flex-1" data-id="element-443" data-mp="2dbwj1i28lasg">
        <p className="text-lg italic leading-relaxed text-white" data-id="element-444" data-mp="2i8mzw7lv8aex">“{t(testimonial.quote)}”</p>
      </blockquote>
      <figcaption className="mt-8 flex items-center gap-4 border-t border-white/15 pt-6" data-id="element-445" data-mp="biffaph88u2z">
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gold font-display font-bold text-navy" aria-hidden="true" data-id="element-446" data-mp="gibjaopxclij">
          {initials}
        </span>
        <div className="min-w-0" data-id="element-447" data-mp="2xid4nnvbov0e">
          <p className="font-bold text-gold" data-id="element-448" data-mp="2xj65673ouoa3">{testimonial.name}</p>
          <p className="text-sm text-[#BCC7D1]" data-id="element-449" data-mp="3b9ro1vt56y7z">
            {t(testimonial.relationship)} · Google · {t(testimonial.date)}
          </p>
        </div>
      </figcaption>
    </figure>;
}